import React from 'react';
import { makeStyles } from '@mui/styles';
import { TableRow, TableCell, Typography } from '@mui/material';
import NutrientItemTitle from './NutrientItemTitle';

const useStyles = makeStyles((theme) => ({
  mobileRow: {
    '& td': {
      borderBottom: 'none',
      padding: '16px 0',
    },
  },
  mobileTitle: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '8px',
    width: '100%',
    justifyContent: 'flex-start',
    padding: '0 8px',
  },
  mobileUnits: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  mobileUnit: {
    width: '33.33%',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '40px',
  },
  mobileUnitValue: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    height: '100%',
  },
  mobileSliders: {
    display: 'flex',
    gap: '7px',
    width: '100%',
    justifyContent: 'center',
  },
  unitRegular: theme.globalClasses.unitRegular,
  unitBold: theme.globalClasses.unitBold,
}));

const MobileNutrientRow = ({ item, calculatedChange, longDescription }) => {
  const classes = useStyles();
  const hasGoal = 'goal' in item;

  return (
    <TableRow className={classes.mobileRow}>
      <TableCell colSpan={3}>
        {hasGoal ? (
          <>
            <div className={classes.mobileTitle}>
              <NutrientItemTitle
                name={item.name}
                longDescription={longDescription}
              />
            </div>
            <div className={classes.mobileUnits}>
              <div className={classes.mobileUnit}>
                <div className={classes.mobileUnitValue}>
                  <Typography className={classes.unitBold}>{item.current}</Typography>
                  <Typography className={classes.unitRegular}>{item.unit}</Typography>
                </div>
              </div>
              <div className={classes.mobileUnit}>
                <div className={classes.mobileUnitValue}>
                  <Typography className={classes.unitBold}>{item.goal}</Typography>
                  <Typography className={classes.unitRegular}>{item.unit}</Typography>
                </div>
              </div>
              <div className={classes.mobileUnit}>{calculatedChange}</div>
            </div>
          </>
        ) : (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 8px' }}>
            <div style={{ flex: 1 }}>
              <NutrientItemTitle
                name={item.name}
                longDescription={longDescription}
              />
            </div>
            <div className={classes.mobileUnitValue}>
              <Typography className={classes.unitBold}>{item.current}</Typography>
              <Typography className={classes.unitRegular}>{item.unit}</Typography>
            </div>
          </div>
        )}
      </TableCell>
    </TableRow>
  );
};

export default MobileNutrientRow;
